import React, { useState } from 'react';

import RequestService from "../../services/request.service";

import AuthService from '../../features/auth/auth.service'

import { Button, Modal } from 'react-bootstrap'

import { toast } from 'react-toastify'

import { Form, Col, Row } from 'react-bootstrap'

import { Formik } from 'formik';
import * as yup from 'yup';

import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from 'date-fns/locale/es';


import Dialog from '../../services/Dialogs'

import moment from 'moment'



const ModalEditarFechasAseguramiento = ( params : any ) => {

  const user = AuthService.getCurrentUser()

  const { show, handleClose, tramite } = params

  const dialog = new Dialog();


  const mensajes_validacion_generico = "Este campo es obligatorio"
  const schema = yup.object().shape({
          fecha_alta_anterior : yup.string().required(mensajes_validacion_generico),
          fecha_alta_nuevo : yup.string().required(mensajes_validacion_generico),
          fecha_baja_anterior : yup.string().required(mensajes_validacion_generico),
          fecha_baja_nuevo : yup.string().required(mensajes_validacion_generico),
  });


  const [ envio_server, setSeEnvio ] = useState<boolean>(false)


  const enviarFormulario = async (registro:any,event:any) =>{
        await dialog.open({
          accept: 'Si',
          cancel: 'Espera',
          dialogClass: '',
          message: '¿Estás seguro?',
          target: event.target,
          template: '<small style="max-width:200px">Los cambios a este punto del ciclo de <br>vida del trámite puede afectar severamente la información. <br>Modifica la información solo si estás seguro.</small>'
        })
        let dialogo : any = await dialog.waitForUser()
        if(dialogo){
          try{

          setSeEnvio(true)
          let res_ = await RequestService.update( `aseguramientos/cambio_fechas_mesa/${tramite.uuid_tramite}` , { ...registro, 
                                                                              fecha_alta_anterior : moment(registro.fecha_alta_anterior).format('YYYY-MM-DD'), 
                                                                              fecha_alta_nuevo : moment(registro.fecha_alta_nuevo).format('YYYY-MM-DD'), 
                                                                              fecha_baja_anterior : moment(registro.fecha_baja_anterior).format('YYYY-MM-DD'), 
                                                                              fecha_baja_nuevo : moment(registro.fecha_baja_nuevo).format('YYYY-MM-DD') 
                                                                  })

          if(res_){
            toast.warning('Las fechas se actualizaron correctamente')
            setTimeout(()=>{
              handleClose()
            },0)
          }
          else{
            toast.error('Problemas...')
          } 
          }
          catch(e:any){
            toast.error(e.response.data)
            // console.log(e.response.data)
          } 
          
        }
       
  }



  return (
    <>
      <Modal show={show} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Editar Fechas de Aseguramiento</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            // JSON.stringify(tramite)
          }



    <Formik
      validationSchema={schema}
      onSubmit={(values,e)=>{enviarFormulario(values, e)}}
      initialValues={{
            fecha_alta_anterior : tramite.fecha_alta_anterior === '0000-00-00' || !tramite.fecha_alta_anterior ? new Date() : new Date(moment(tramite.fecha_alta_anterior).toString()),
            fecha_alta_nuevo : tramite.fecha_alta_nuevo === '0000-00-00' || !tramite.fecha_alta_nuevo ? new Date() : new Date(moment(tramite.fecha_alta_nuevo).toString()),
            fecha_baja_anterior : tramite.fecha_baja_anterior === '0000-00-00' || !tramite.fecha_baja_anterior ? new Date() : new Date(moment(tramite.fecha_baja_anterior).toString()),
            fecha_baja_nuevo : tramite.fecha_baja_nuevo === '0000-00-00' || !tramite.fecha_baja_nuevo ? new Date() : new Date(moment(tramite.fecha_baja_nuevo).toString()),
      }}
    >
      {({
        handleSubmit,
        handleChange,
        setFieldValue,
        handleBlur,
        values,
        touched,
        isValid,
        errors,
      }) => (
        <Form id='my-form' noValidate onSubmit={handleSubmit}>


            <div className="row">
              <div className="col-sm-6">
                  <div className="mb-3">
                    <Form.Label>Fecha de Alta Anterior</Form.Label>
                    <DatePicker selected={values.fecha_alta_anterior} className="form-control"  dateFormat="yyyy-MM-dd" maxDate={new Date()} onChange={(date) => setFieldValue('fecha_alta_anterior', date ) } />
                  </div>
              </div>
              <div className="col-sm-6">
                  <div className="mb-3">
                    <Form.Label>Fecha de Alta Nueva</Form.Label>
                    <DatePicker selected={values.fecha_alta_nuevo} className="form-control"  dateFormat="yyyy-MM-dd" maxDate={new Date()} onChange={(date) => setFieldValue('fecha_alta_nuevo', date ) } />
                  </div>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-sm-6">
                  <div className="mb-3">
                    <Form.Label>Fecha de Baja Anterior</Form.Label>
                    <DatePicker selected={values.fecha_baja_anterior} className="form-control"  dateFormat="yyyy-MM-dd" maxDate={new Date()} onChange={(date) => setFieldValue('fecha_baja_anterior', date ) } />
                  </div>
              </div>
              <div className="col-sm-6">
                  <div className="mb-3">
                    <Form.Label>Fecha de Baja Nueva</Form.Label>
                    <DatePicker selected={values.fecha_baja_nuevo} className="form-control"  dateFormat="yyyy-MM-dd" maxDate={new Date()} onChange={(date) => setFieldValue('fecha_baja_nuevo', date ) } />
                  </div>
              </div>
            </div>




        </Form>
      )}
    </Formik>


        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cerrar Ventana
          </Button>
          <Button variant="success" form='my-form' type="submit">Guardar <i className="fa fa-save"/></Button>
        </Modal.Footer>


      </Modal>
    </>
  );
}


export default ModalEditarFechasAseguramiento;